module.exports = __webpack_public_path__ + "img/visa-logo.169c076d.png";